export const TEAM_MEMBERS_INCLUDED_IN_TEAM = 5;
